export default {
    props: {
        isForcedVisible: Boolean,
        isInitialVisible: Boolean,
    },

    data() {
        return {
            isVisible: this.isInitialVisible,
        };
    },

    computed: {
        isFinalVisible() {
            return this.isVisible || this.isForcedVisible;
        },
    },

    methods: {
        show() {
            this.isVisible = true;
        },

        hide() {
            this.isVisible = false;
        },

        toggle(status) {
            if (typeof status === 'undefined') {
                this.isVisible = !this.isVisible;
            } else {
                this.isVisible = status;
            }
        },
    },

    // By default, render the content in the slot and pass the necessary functions to it
    // If you use this mixin in a component with a template, this render function will be overridden
    render: function (createElement) {
        return createElement('div', [
            this.$scopedSlots.default({
                isVisible: this.isFinalVisible,
                show: this.show,
                hide: this.hide,
                toggle: this.toggle,
            })
        ])
    }
}
